export default async function updateCurrentUser(user) {
  Devise.updateSession(user)
  Devise.events().emit("onDeviseSignIn")
  await CanCan.current().resetAbilities()
}
